import React, { ComponentType, memo } from 'react';

import styled from 'styled-components';

import { compose } from 'redux';

import Box from '../atoms/Box/Box';
import Button from '../atoms/Button/Button';
import Text from '../atoms/Text/Text';

import { Color } from '@shared/enums/button-color';
import { I18nTranslation } from '@shared/interfaces/i18n';
import Router from 'next/router';
import { Size } from '@shared/enums/button-size';
import { withTranslation } from 'i18n';

type SubscriptionsAdProps = {
  t?: I18nTranslation;
};

function SubscriptionsAd({ t: tProp }: SubscriptionsAdProps) {
  const t = (key, options?) => tProp(`ad.${key}`, options);

  const features = (t('features', { returnObjects: true }) as []).map(
    (feature, i) => <li key={i}>{feature}</li>
  );

  const handleClick = () => {
    Router.push('/#features-table');
  };

  return (
    <Wrapper>
      <Box mb={0.875}>
        <Text component="p" weight="bold" size={1.125} lineHeight={1.5}>
          {t('title')}
        </Text>
      </Box>
      <List>{features}</List>
      <Box mb={0.875}>
        <Text component="p" weight="bold" size={1.125} lineHeight={1.5}>
          {t('coffee')}
        </Text>
      </Box>
      <Button
        onClick={handleClick}
        colorType={Color.FullGreen}
        sizeType={Size.Three}
      >
        {t('compare')}
      </Button>
    </Wrapper>
  );
}

export default compose<ComponentType<SubscriptionsAdProps>>(
  memo,
  withTranslation('account')
)(SubscriptionsAd);

const Wrapper = styled.div`
  padding: 0.75em 1.125em 1.125em;
  border: 1px solid ${({ theme }) => theme.colors.turquoise};
  background-color: ${({ theme }) => theme.transparentColors.turquoise10};
`;

const List = styled('ul')`
  li {
    background: url('/icons/checkbox.svg') no-repeat left 5px;
    background-size: 19px 19px;
    padding-left: 26px;
    margin-bottom: 0.625em;
    line-height: 1.5;
    font-size: 18px;
  }
`;
